import React from "react";
import { Typography, Avatar } from "antd";
import { useGenders, useFamilyStatus, useEmployee_types } from "../../hooks";
import { getFullName } from "../util/helpers";
import { useIntl } from "react-intl";
import { useParams, useLocation } from "react-router-dom";

import { CheckCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
const { Title, Text } = Typography;

const EmployeeDetails = (props) => {
  const { activeEvent } = props;
  const intl = useIntl();
  let location = useLocation();
  let { branchId } = useParams();
  const allGenders = useGenders();
  const allFamilyStatuses = useFamilyStatus();
  const allEmployee_types = useEmployee_types();
  const employee =
    activeEvent && activeEvent.employee ? activeEvent.employee : null;
  const name = employee
    ? getFullName(employee.surename, employee.first_name)
    : "";
  const employee_type =
    employee && employee["employee_type_id"] && allEmployee_types
      ? allEmployee_types.filter(
          (item) => item.id === employee["employee_type_id"]
        )[0]
      : null;
  let familyGenderArray = [];

  const familyStatus =
    employee && employee["family_status"] && allFamilyStatuses
      ? allFamilyStatuses.filter(
          (item) => item.id === employee["family_status"]
        )[0]
      : null;

  if (familyStatus) {
    familyGenderArray.push(
      intl.formatMessage({
        id: "app.dataSelect.family_status." + familyStatus.name,
      })
    );
  }

  const gender =
    employee && employee["gender_id"]
      ? allGenders.filter((item) => item.id === employee["gender_id"])[0]
      : null;
  if (gender) {
    familyGenderArray.push(
      intl.formatMessage({
        id: "app.dataSelect.gender_id." + gender.name,
      })
    );
  }

  const street =
    employee && employee["address"] && employee["address"].street
      ? employee["address"].street + " " + employee["address"].house_number
      : "";
  const address =
    employee && employee["address"] && employee["address"].city !== undefined
      ? employee["address"].city + ", " + street
      : street;

  const letter = name.charAt(0);
  const isAdmin = location.pathname.includes("admin");
  const linkPath =
    isAdmin && employee
      ? `/admin/employees/${employee.id}`
      : employee && `/branches/${branchId}/employees/${employee.id}`;
  return (
    <div className="employee-container">
      <div className="employee">
        <div className="avatar">
          {employee && employee["avatar_url"] ? (
            <Avatar src={employee["avatar_url"]} />
          ) : (
            <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
              {letter}
            </Avatar>
          )}
        </div>
        <div style={{ width: "30px" }} />
        <div className="employee-details">
          <Link
            style={{ color: "inherit" }}
            to={{
              pathname: linkPath,
            }}
          >
            <Title level={2} style={{ textDecoration: "underline" }}>
              {name}
            </Title>
          </Link>

          <Title level={5}>{address}</Title>
          <div className="seperator" />
          {employee_type && (
            <div className="employee-type">
              <Text type="secondary">
                {intl.formatMessage({
                  id: "app.employees.employee_type_id",
                })}
              </Text>
              <Title level={5}>
                {intl.formatMessage({
                  id: "app.dataSelect.employee_type_id." + employee_type.name,
                })}
              </Title>
            </div>
          )}

          {familyGenderArray && (
            <Title level={5}>{familyGenderArray.join(", ")}</Title>
          )}
          {activeEvent &&
            activeEvent.ghostEmployeeId === activeEvent.employee_id && (
              <Title style={{ color: "red" }} level={5}>
                {intl.formatMessage({
                  id: `app.scheduling.replacedEmployee`,
                })}
              </Title>
            )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
